export {
    platformTranslates,
    platforms,
    platformFilterTranslates,
    platformFilterOptions,
} from './platforms';
export { programTypeTranslates, programTypes } from './program-type';
export { PLATOONS_COMPANY_OPTIONS } from './platoons';
